// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__30AYd","container":"styles_container__11N67","title":"styles_title__N600b","wrapper":"styles_wrapper__2Vbrv","answer":"styles_answer__eLII6"};